<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Choose Method</v-card-title>

        <v-card-text>
            <v-list>
                <v-list-item
                    v-on:click="onChooseNote"
                >  
                    <v-list-item-avatar><v-icon>mdi-content-copy</v-icon></v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>Copy Conversation To A Note</v-list-item-title>
                        <v-list-item-content>A specially formatted note including all text, files and payments in the conversation to date will be placed on your clipboard for easy pasting into a note in the Client Profile. </v-list-item-content>
                    </v-list-item-content>

                </v-list-item>

                <v-list-item
                    v-on:click="onChooseAdf"
                >  
                    <v-list-item-avatar><v-icon>mdi-send</v-icon></v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>Send Link To The Live Conversation</v-list-item-title>
                        <v-list-item-content>A lead in Auto-lead Data Format (ADF) will be sent to your CRM. The note will contain a URL to this live, interactive and always-up-to-date conversation in RedChirp.</v-list-item-content>
                    </v-list-item-content>

                </v-list-item>
                
            </v-list>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            dialog: false,

            params: null,
        }
    },

    methods: {

        showDialog(params)
        {
            this.params = params;
            this.dialog = true;
        },

        onChooseNote()
        {
            this.dialog = false;

            this.$router.push({
                'name': 'integration-adf-add-note',
                'params' : this.params,
            }).catch(e=>{}); // swallow any exception
        },

        onChooseAdf()
        {
            this.dialog = false;

            this.$router.push({
                'name': 'integration-adf-send',
                'params' : this.params,
            }).catch(e=>{}); // swallow any exception
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}

</script>

<style lang="scss" scoped>
</style>